<template>
    <Transition v-if="isLoading"
                name="spinner">
        <div id="cover-spin">
            <span class="loader">
                <span>{{ $spinnerText }}</span>
            </span>
        </div>
    </Transition>

    <v-form :name="props.formProps.formName">
        <Tabs value="0"
              scrollable>

            <TabList>
                <Tab value="0">{{ __('Basic data') }}</Tab>
            </TabList>

            <TabPanels>
                <TabPanel value="0">
                    <div class="grid">
                        <FormSelect fieldName="seller_id"
                                    label="Seller"
                                    size="3"
                                    :isFormDisabled="isFormDisabled"
                                    :options="select?.sellers"
                                    v-model:field="crud.seller_id" />

                        <FormInputText fieldName="marketplace_code"
                                       label="Marketplace"
                                       size="2"
                                       :isFormDisabled="isFormDisabled"
                                       v-model:field="crud.marketplace_code" />

                        <FormInputText fieldName="identity"
                                       label="Product ID"
                                       size="5"
                                       :isFormDisabled="isFormDisabled"
                                       v-model:field="crud.identity" />

                        <FormInputText fieldName="identity_type"
                                       label="ID type"
                                       size="2"
                                       :isFormDisabled="isFormDisabled"
                                       v-model:field="crud.identity_type" />

                        <FormInputText fieldName="offer_identity"
                                       label="Offer ID"
                                       size="4"
                                       :isFormDisabled="isFormDisabled"
                                       v-model:field="crud.offer_identity" />

                        <FormInputNumber fieldName="price"
                                         label="Price"
                                         size="3"
                                         :isFormDisabled="isFormDisabled"
                                         :minFractionDigits="2"
                                         :maxFractionDigits="2"
                                         v-model:field="crud.price" />

                        <FormInputText fieldName="currency"
                                       label="Currency"
                                       size="2"
                                       :isFormDisabled="isFormDisabled"
                                       v-model:field="crud.currency" />

                        <FormInputNumber fieldName="quantity"
                                         label="Quantity"
                                         size="3"
                                         :isFormDisabled="isFormDisabled"
                                         :minFractionDigits="2"
                                         :maxFractionDigits="2"
                                         v-model:field="crud.quantity" />

                        <FormInputText fieldName="status"
                                       label="Status"
                                       size="3"
                                       :isFormDisabled="isFormDisabled"
                                       v-model:field="crud.status" />

                        <FormInputText fieldName="title"
                                       label="Product name"
                                       size="9"
                                       :isFormDisabled="isFormDisabled"
                                       v-model:field="crud.title" />

                        <FormInputText fieldName="subtitle"
                                       label="Additional name"
                                       size="9"
                                       :isFormDisabled="isFormDisabled"
                                       v-model:field="crud.subtitle" />

                        <FormInputText fieldName="last_synced_at"
                                       label="Last synced at"
                                       size="3"
                                       :isFormDisabled="isFormDisabled"
                                       v-model:field="crud.last_synced_at" />

                        <FormInputText fieldName="offer_url"
                                       label="Offer URL"
                                       :isFormDisabled="isFormDisabled"
                                       v-model:field="crud.offer_url" />
                    </div>
                    <div class="grid">
                        <FormTextarea fieldName="raw_data"
                                      label="Raw data"
                                      :isFormDisabled="isFormDisabled"
                                      v-model:field="crud.raw_data" />
                    </div>
                </TabPanel>
            </TabPanels>
        </Tabs>

        <div class="grid">
            <FormButtons :formProps="props.formProps"
                         :sourceForm="crud"
                         :validation="validation"
                         :buttonsVisibility="buttonsVisibility"
                         v-model:isFormDisabled="isFormDisabled">
            </FormButtons>
        </div>
    </v-form>
</template>

<script setup>
import { ref, onMounted, onBeforeMount } from "vue";

import Tabs from 'primevue/tabs';
import TabList from 'primevue/tablist';
import Tab from 'primevue/tab';
import TabPanels from 'primevue/tabpanels';
import TabPanel from 'primevue/tabpanel';

import { validation, initForm } from "@pages/Helper/crud_utils.js";
import FormInputText from "@crud/FormInputText.vue";
import FormButtons from "@crud/FormButtons.vue";
import FormStaticText from "@crud/FormStaticText.vue";
import FormSelect from "@crud/FormSelect.vue";
import FormInputNumber from "@crud/FormInputNumber.vue";
import FormTextarea from "@crud/FormTextarea.vue";
import ChangeLog from "@crud/ChangeLog.vue";
import { __, screenMessage, getConfigOptions, getFromRoute } from "@pages/Helper/utils.js";
import { onFilterService } from "@pages/Helper/crud_utils.js";

// -----------------------------------------------------

const props = defineProps({
    formProps: Object,
});

const isLoading = ref(true);
const isFormDisabled = ref(false);

const options = ["sellers"];
const select = ref(null);
const crud = ref({});
const buttonsVisibility = ref({});

// -----------------------------------------------------

onMounted(async () => {
    await initForm(props, crud, isLoading, options, select, buttonsVisibility);
    crud.value.raw_data = JSON.stringify(crud.value.raw_data, null, 4)
});

// -----------------------------------------------------

</script>

<style lang="scss" scoped>
.json-textarea textarea,
.json-textarea .p-inputtextarea {
    font-family: monospace !important;
    white-space: pre-wrap !important;
    min-height: 400px;
}
</style>
